import {Alert, Button, CircularProgress, Container, Divider, FormControl, Grid, InputLabel, Link, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography} from "@mui/material"
import React from "react"
import {useNavigate} from 'react-router-dom';
import {parseToMoney} from "../../util/StringUtils";
import {Add, Close, Delete, Done, Edit} from "@mui/icons-material";
import VisuallyHiddenInput from "../common/VisuallyHiddenInput";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import {download} from "../../services/FileService";

const columns = [
    {id: 'serialNumber', label: 'Azonosító'},
    {id: 'name', label: 'Név'},
    {id: 'sender', label: 'Feladó'},
    {id: 'receiver', label: 'Címzett'},
    {id: 'amount', label: 'Összeg'},
    {id: 'deadline', label: 'Határidő'},
    {id: 'paymentType', label: 'Fizetés Módja'},
    {id: 'invoiceType', label: 'Számla Típusa'},
    {id: 'paid', label: 'Teljesítve', align: "right"},
    {id: 'paidBy', label: 'Teljesítette', align: "center"},
    {id: 'paidAt', label: 'Teljesítés Dátuma', align: "center"},
    {id: 'documentNames', label: 'Dokumentumok'},
    {id: 'createdAt', label: 'Hozzáadva'}
];

const fileColumns = [
    {id: 'name', label: 'Fájl Neve'},
    {id: 'description', label: 'Leírás'},
    {id: 'createdAt', label: 'Feltöltve'},
    {id: 'uploadedBy', label: 'Feltöltő'},
];

export default function VehicleEditorTemplate(props) {

    const [open, setOpen] = React.useState(false);
    const [currentItem, setCurrentItem] = React.useState(undefined);

    const handleClickOpen = (item) => {
        setCurrentItem(item)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const {id, onChange, create, update, message, tableData, downloadSimpleInvoice} = props

    const {
        licensePlate,
        technicalValidity,
        odometer,
        primaryHighwayVignetteCategory,
        primaryHighwayVignetteValidity,
        primaryHighwayVignetteExpiryDate,
        secondaryHighwayVignetteCategory,
        secondaryHighwayVignetteValidity,
        secondaryHighwayVignetteExpiryDate,
        insuranceCompanyName,
        insuranceValidity,
        lastEngineOilChange,
        active,
        createdAt,
        updatedAt
    } = props.vehicle

    const navigate = useNavigate();

    const renderCellValue = (column, value, row) => {
        switch (column) {
            case 'amount':
                return parseToMoney(value)
            case 'paid':
                return value === true ? <Done color='success'/> : value;
            case 'paidBy':
                return value?.name;
            case 'documentNames':
                return (
                    <Link onClick={(e) => {
                        e.stopPropagation()
                        downloadSimpleInvoice(row.id, value[0])
                    }}
                          sx={{textDecoration: "none", cursor: "pointer", fontWeight: "bold"}}>
                        {value[0]}
                    </Link>)
            default:
                return value
        }
    }

    return (
        <div>
            <Container component="main">
                <div className="register-paper">
                    <form id="login" onSubmit={id ? update : create}>
                        <Grid container spacing={2} columns={20}>
                            {createTextField("licensePlate", "Rendszám", licensePlate, onChange, true, true)}
                            {createTextField("lastEngineOilChange", "Utolsó Olajcsere", lastEngineOilChange, onChange)}
                            {createTextField("odometer", "Kilométer óra állása", odometer, onChange)}


                            <Grid item lg={5} md={10} xs={20}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id={"technicalValidity"}
                                    label={"Műszaki Érvényesség Lejárta"}
                                    name={"technicalValidity"}
                                    type="date"
                                    slotProps={{inputLabel: {shrink: true}}}
                                    autoComplete="off"
                                    onChange={onChange}
                                    value={technicalValidity || "-1"}
                                />
                            </Grid>

                            <Grid item lg={5} md={10} xs={20}>
                                <Typography style={{marginTop: "30px", marginRight: "30px", textAlign: "right"}}>Elsődleges
                                    Autópálya Matrica</Typography>
                            </Grid>

                            <Grid item lg={5} md={10} xs={20}>
                                <FormControl sx={{minWidth: 120, marginTop: "16px"}} fullWidth>
                                    <InputLabel id="category">Kategória</InputLabel>
                                    <Select
                                        variant="outlined"
                                        fullWidth
                                        id="primaryHighwayVignetteCategory"
                                        labelId="category"
                                        name="primaryHighwayVignetteCategory"
                                        label="Kategória"
                                        value={primaryHighwayVignetteCategory}
                                        onChange={onChange}
                                        sx={{textAlign: "left"}}
                                    >
                                        <MenuItem value={undefined}
                                                  style={{color: "darkgray", fontStyle: "italic"}}>Nincs</MenuItem>
                                        <MenuItem value={"D1"}>D1</MenuItem>
                                        <MenuItem value={"D2"}>D2</MenuItem>
                                        <MenuItem value={"U"}>U</MenuItem>
                                        <MenuItem value={"D1M"}>D1M</MenuItem>
                                        <MenuItem value={"B2"}>B2</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item lg={5} md={10} xs={20}>
                                <FormControl sx={{minWidth: 120, marginTop: "16px"}} fullWidth>
                                    <InputLabel id="validity">Érvényesség</InputLabel>
                                    <Select
                                        variant="outlined"
                                        fullWidth
                                        id="primaryHighwayVignetteValidity"
                                        labelId="validity"
                                        name="primaryHighwayVignetteValidity"
                                        label="Érvényesség"
                                        value={primaryHighwayVignetteValidity}
                                        onChange={onChange}
                                        sx={{textAlign: "left"}}
                                    >
                                        <MenuItem value={undefined}
                                                  style={{color: "darkgray", fontStyle: "italic"}}>Nincs</MenuItem>
                                        <MenuItem value={"Heti"}>Heti</MenuItem>
                                        <MenuItem value={"Havi"}>Havi</MenuItem>
                                        <MenuItem value={"Éves Vármegyei"}>Éves Vármegyei</MenuItem>
                                        <MenuItem value={"Éves Országos"}>Éves Országos</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item lg={5} md={10} xs={20}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id={"primaryHighwayVignetteExpiryDate"}
                                    label={"Lejárati Dátum"}
                                    name={"primaryHighwayVignetteExpiryDate"}
                                    type="date"
                                    slotProps={{inputLabel: {shrink: true}}}
                                    autoComplete="off"
                                    onChange={onChange}
                                    value={primaryHighwayVignetteExpiryDate ? primaryHighwayVignetteExpiryDate : "-1"}
                                />
                            </Grid>

                            <Grid item lg={5} md={10} xs={20}>
                                <Typography style={{marginTop: "30px", marginRight: "30px", textAlign: "right"}}>Másodlagos
                                    Autópálya Matrica</Typography>
                            </Grid>

                            <Grid item lg={5} md={10} xs={20}>
                                <FormControl sx={{minWidth: 120, marginTop: "16px"}} fullWidth>
                                    <InputLabel id="category">Kategória</InputLabel>
                                    <Select
                                        variant="outlined"
                                        fullWidth
                                        labelId="category"
                                        id="secondaryHighwayVignetteCategory"
                                        name="secondaryHighwayVignetteCategory"
                                        label="Kategória"
                                        value={secondaryHighwayVignetteCategory}
                                        onChange={onChange}
                                        sx={{textAlign: "left"}}
                                    >
                                        <MenuItem value={undefined}
                                                  style={{color: "darkgray", fontStyle: "italic"}}>Nincs</MenuItem>
                                        <MenuItem value={"D1"}>D1</MenuItem>
                                        <MenuItem value={"D2"}>D2</MenuItem>
                                        <MenuItem value={"U"}>U</MenuItem>
                                        <MenuItem value={"D1M"}>D1M</MenuItem>
                                        <MenuItem value={"B2"}>B2</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item lg={5} md={10} xs={20}>
                                <FormControl sx={{minWidth: 120, marginTop: "16px"}} fullWidth>
                                    <InputLabel id="validity">Érvényesség</InputLabel>
                                    <Select
                                        variant="outlined"
                                        fullWidth
                                        id="secondaryHighwayVignetteValidity"
                                        labelId="validity"
                                        name="secondaryHighwayVignetteValidity"
                                        label="Érvényesség"
                                        value={secondaryHighwayVignetteValidity || ""}
                                        onChange={onChange}
                                        sx={{textAlign: "left"}}
                                    >
                                        <MenuItem value={undefined}
                                                  style={{color: "darkgray", fontStyle: "italic"}}>Nincs</MenuItem>
                                        <MenuItem value={"Heti"}>Heti</MenuItem>
                                        <MenuItem value={"Havi"}>Havi</MenuItem>
                                        <MenuItem value={"Éves Vármegyei"}>Éves Vármegyei</MenuItem>
                                        <MenuItem value={"Éves Országos"}>Éves Országos</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item lg={5} md={10} xs={20}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id={"secondaryHighwayVignetteExpiryDate"}
                                    label={"Lejárati Dátum"}
                                    name={"secondaryHighwayVignetteExpiryDate"}
                                    type="date"
                                    slotProps={{inputLabel: {shrink: true}}}
                                    autoComplete="off"
                                    onChange={onChange}
                                    value={secondaryHighwayVignetteExpiryDate ? secondaryHighwayVignetteExpiryDate : "-1"}
                                />
                            </Grid>

                            <Grid item lg={5} md={10} xs={20}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id={"insuranceCompanyName"}
                                    label={"Biztosító Cég Neve"}
                                    name={"insuranceCompanyName"}
                                    type="text"
                                    autoComplete="off"
                                    onChange={onChange}
                                    value={insuranceCompanyName || ""}
                                />
                            </Grid>


                            <Grid item lg={5} md={10} xs={20}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id={"insuranceValidity"}
                                    label={"Biztosítás Lejárati Dátuma"}
                                    name={"insuranceValidity"}
                                    type="date"
                                    slotProps={{inputLabel: {shrink: true}}}
                                    autoComplete="off"
                                    onChange={onChange}
                                    value={insuranceValidity ? insuranceValidity : "-1"}
                                />
                            </Grid>

                            <Grid item lg={5} md={10} xs={20}>
                                <FormControl sx={{m: 1, minWidth: 120, marginTop: "16px", marginLeft: "0px"}} fullWidth>
                                    <InputLabel id="activeTemplateLabel">Státusz</InputLabel>
                                    <Select
                                        variant="outlined"
                                        required
                                        fullWidth
                                        name="active"
                                        label="Státusz"
                                        labelId="activeTemplateLabel"
                                        value={active || false}
                                        onChange={onChange}
                                        sx={{textAlign: "left"}}
                                        defaultValue={true}
                                    >
                                        <MenuItem value={true}>Aktív</MenuItem>
                                        <MenuItem value={false}>Inaktív</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {id !== undefined &&
                                <>
                                    <Grid item lg={20} md={20} xs={20}>
                                        <Divider/>
                                    </Grid>

                                    {createTextField("createdAt", "Létrehozva", createdAt, onChange, false, false, true)}
                                    {createTextField("updatedAt", "Módosítva", updatedAt, onChange, false, false, true)}
                                </>

                            }


                            {message &&
                                <Grid item lg={20} xs={20}>
                                    <Alert severity="error" variant="standard" style={{color: "red"}}>{message}</Alert>
                                </Grid>
                            }

                            <Grid item lg={20} md={20} xs={20}></Grid>
                            <Grid item lg={2} md={5} xs={9}>
                                <Button type="button" fullWidth variant="contained" color="error"
                                        onClick={() => navigate("/dashboard/vehicles")}>
                                    Vissza
                                </Button>
                            </Grid>

                            <Grid item lg={16} md={10} xs={2}></Grid>

                            <Grid item lg={2} md={5} xs={9}>
                                <Button type="submit" fullWidth variant="contained" color="success">
                                    Mentés
                                </Button>
                            </Grid>

                        </Grid>
                        <Grid item xs={20}>
                            <Grid container spacing={2} columns={5} sx={{marginTop: "4px"}}>
                                {(props.vehicle?.files?.length > 0 || props.files?.length > 0) &&
                                    <Grid item xs={5}>
                                        <Table sx={{marginTop: "16px"}}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell key="actions"
                                                               style={{fontWeight: 700, background: "lightgray", minWidth: "50px"}}
                                                               align='left' padding='none' sx={{paddingLeft: "8px"}}>
                                                        <Button variant='contained' color='success' component={'label'}
                                                                sx={{minWidth: "0px", padding: "0px", marginRight: "10px"}}>
                                                            <VisuallyHiddenInput type="file" multiple
                                                                                 onChange={props.handleFileChange}/>
                                                            <Add fontSize="large"/>
                                                        </Button>
                                                    </TableCell>
                                                    {fileColumns.map((column) => (
                                                        <TableCell key={column.id} align={column.align}
                                                                   style={{fontWeight: 700, background: "lightgray"}}>
                                                            {column.label}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {props.vehicle?.files?.map((file, index) => (
                                                    <TableRow>
                                                        <TableCell sx={{width: "50px", padding: "0px"}}>
                                                            <Button
                                                                onClick={() => props.removeDocumentName(file.id)}
                                                                variant="text" color='error' sx={{
                                                                marginLeft: "10px",
                                                                padding: "5px",
                                                                minWidth: "0px"
                                                            }}>
                                                                <Delete/>
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell key={index}
                                                                   sx={{textAlign: "left", padding: "5px"}}>
                                                            <Link
                                                                onClick={() => download(file.name, `/cloud-storage-files/${file.id}`, props.sendAlertMessage)}
                                                                sx={{
                                                                    textDecoration: "none",
                                                                    cursor: "pointer",
                                                                    fontWeight: "bold"
                                                                }}>{file.name}</Link>
                                                        </TableCell>
                                                        <TableCell>
                                                                <span style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: "0px"}}>
                                                                    <span style={{flexGrow: 1, textAlign: 'left'}}>{file.description}</span>
                                                                    <Button onClick={() => handleClickOpen(file)} variant="text" sx={{minWidth: '0px', padding: '5px', marginLeft: 'auto'}}>
                                                                        <Edit/>
                                                                    </Button>
                                                                </span>
                                                        </TableCell>

                                                        <TableCell>{file.createdAt}</TableCell>
                                                        <TableCell>{file.uploadedBy?.name}</TableCell>
                                                    </TableRow>
                                                ))}
                                                {props.files.map((file, index) => (
                                                    <TableRow>
                                                        <TableCell sx={{width: "50px", padding: "0px"}}>
                                                            <Button
                                                                onClick={() => props.handleRemoveFile(index)}
                                                                variant="text" color='error' sx={{
                                                                marginLeft: "10px",
                                                                padding: "5px",
                                                                minWidth: "0px"
                                                            }}>
                                                                <Close/>
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell key={index} sx={{
                                                            textAlign: "left",
                                                            padding: "0px 0px 0px 5px"
                                                        }}>
                                                            {file.name} {' ('}{(new Intl.NumberFormat().format((file.size / 1024).toFixed(2))).replace(',', '.')} KB{')'}
                                                        </TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>

                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Grid>}
                            </Grid>
                        </Grid>
                    </form>
                </div>

                <Paper sx={{width: '100%', overflow: 'hidden', marginTop: '16px'}}>
                    <TableContainer>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell key={column.id} align={column.align} style={{
                                            fontWeight: 700,
                                            background: "lightgray",
                                            width: column.width
                                        }}>
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.rows == null ?
                                    <TableRow sx={{textAlign: "center"}}>
                                        <TableCell colSpan={16} sx={{padding: "200px", textAlign: "center"}}><CircularProgress/></TableCell>
                                    </TableRow> :
                                    tableData.rows.map((row) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                                {columns.map((column) => {
                                                    const value = renderCellValue(column.id, row[column.id], row);
                                                    return (
                                                        <TableCell key={column.id} align={column.align}
                                                                   onClick={() => navigate("/dashboard/simple-invoices/" + row.id)}
                                                                   sx={{cursor: "pointer", padding: "0px 10px"}}>
                                                            {value}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[3, 10, 25, 50]}
                        component="div"
                        count={tableData.totalCount}
                        rowsPerPage={parseInt(tableData.rowsPerPage)}
                        page={tableData.page}
                        onPageChange={props.onPageChange}
                        onRowsPerPageChange={props.onRowsPerPageChange}
                        labelRowsPerPage="Elemek oldalanként:"
                    />
                </Paper>
            </Container>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries((formData).entries());
                        props.updateFileDescription(currentItem.id, formJson)
                        handleClose();
                    },
                }}
            >
                <DialogTitle sx={{background: "#1976d2", color: "white"}}>
                    Fájl Leírás Módosítása
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        name="description"
                        label="Leírás"
                        fullWidth
                        autoComplete="off"
                        defaultValue={currentItem?.description}
                        variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="submit" variant="contained"
                            sx={{marginRight: "auto"}}>Mentés</Button>
                    <Button onClick={handleClose} color="error"
                            variant="outlined">Mégse</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

function createTextField(name, label, value, onChange, required = false, autoFocus = false, disabled = false) {
    return (<Grid item lg={5} md={10} xs={20}>
        <TextField
            variant="outlined"
            margin="normal"
            required={required}
            fullWidth
            id={name}
            label={label}
            name={name}
            type="text"
            autoFocus={autoFocus}
            autoComplete="off"
            onChange={onChange}
            value={value || ""}
            disabled={disabled}
        />
    </Grid>)
}